import { HasShowHideLogic } from "../logic/has-show-hide-logic.model";
import { ShowHideLogicMetadata, ShowHideLogicMetadataBase } from "../logic/show-hide-logic-metadata.model";
import { ItemMetadataBase } from "./item-metadata.model";


export class BooleanItemMetadataBase extends ItemMetadataBase implements HasShowHideLogic {

    value: boolean = false
    logicShowHideSection: ShowHideLogicMetadata[] = [new ShowHideLogicMetadataBase()];
    logicShowHideField: ShowHideLogicMetadata[] = [new ShowHideLogicMetadataBase()]

    constructor(type: string) {
        super(type)
        this.defaultValue = false
    }

}

export interface BooleanItemMetadata extends BooleanItemMetadataBase { }